import axios from 'axios';

// eslint-disable-next-line import/prefer-default-export
export const getsocialsAccountsLite = id =>
  axios.get(`/lite/user/${id}/social-networks`);
